import { Component } from "@angular/core";
import { faGem } from "@fortawesome/free-regular-svg-icons";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { SizeProp } from "@fortawesome/fontawesome-svg-core";

@Component({
  selector: "app-diamond-text-icon",
  template: '<fa-icon [icon]="faGem" [size]="size"></fa-icon>',
  standalone: true,
  imports: [FaIconComponent],
  styleUrls: ["./diamond-text-icon.component.scss"],
})
export class DiamondTextIconComponent {
  size = "sm" as SizeProp;
  faGem = faGem;
}
